export default function lastAction(state = null, action) {
  return action;
}
